export default __webpack_public_path__ + "static/media/Step4.1c723dcb.svg";